import React from 'react';
import { StraightDots } from '../icons/solid/StraightDots';
import * as ClearButton from '../button/ClearButton';
import { Chevron } from '../icons/outline/Chevron';
import styled, { css } from '../../styled';
const Container = styled.div `
  display: flex;

  > button {
    display: inline-flex;
  }
`;
const SelectorWrapper = styled.div `
  display: inline-flex;
  button {
    border-radius: 6px;
  }
`;
const PageItemWrapper = styled.div `
  margin: 0 0.5rem;
  display: flex;
  box-shadow: 0 0.0625rem 0.125rem 0.0625rem rgba(54, 62, 81, 0.05),
    0 0 1.5rem 0 rgba(54, 62, 81, 0.05);
  border-radius: 6px;
  overflow: hidden;
`;
const ArrowButtonContainer = styled(ClearButton.Default) `
  &:not(:active) {
    background-color: ${({ theme }) => theme.colors.SNOW_400};
  }

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.PRIMARY_200};
    span {
      color: ${({ theme }) => theme.colors.PRIMARY_600};
    }
  }
`;
const PageButtonContainer = styled.div `
  ${props => !props.isActive &&
    css `
      > button:not(:active) {
        background-color: ${({ theme }) => theme.colors.SNOW_400};
      }
    `}

  ${props => props.isActive &&
    css `
      pointer-events: none;
    `}
`;
const renderPageItemButton = (isActive, item, onPageItemClick) => {
    const Component = isActive ? ClearButton.Primary : ClearButton.Default;
    return (React.createElement(PageButtonContainer, { isActive: isActive, key: `pageIndex-${item}` },
        React.createElement(Component, { height: "SQUARE", width: "SQUARE", borderRadius: "NONE", onClick: onPageItemClick(item) }, item)));
};
const shouldRenderExpansion = (judegmentPage, edgePage) => {
    return Math.abs(judegmentPage - edgePage) > 1;
};
const PaginatorView = ({ onLeftArrowClick, onRightArrowClick, onLeftExpandClick, onRightExpandClick, onPageItemClick, minPage = 1, maxPage, currentPage, pageArr, }) => {
    return (React.createElement(Container, null,
        React.createElement(SelectorWrapper, null,
            React.createElement(ArrowButtonContainer, { disabled: currentPage === minPage, Icon: Chevron, iconPosition: "LEFT", onClick: onLeftArrowClick, height: "SQUARE", width: "SQUARE", borderRadius: "NONE" })),
        React.createElement(PageItemWrapper, null,
            shouldRenderExpansion(pageArr[0], minPage) &&
                renderPageItemButton(currentPage === minPage, minPage, onPageItemClick),
            shouldRenderExpansion(pageArr[0], minPage) && (React.createElement(ClearButton.Default, { Icon: StraightDots, height: "SQUARE", width: "SQUARE", borderRadius: "NONE", onClick: onLeftExpandClick })),
            pageArr.map(item => renderPageItemButton(currentPage === item, item, onPageItemClick)),
            shouldRenderExpansion(pageArr[pageArr.length - 1], maxPage) && (React.createElement(ClearButton.Default, { Icon: StraightDots, height: "SQUARE", width: "SQUARE", borderRadius: "NONE", onClick: onRightExpandClick })),
            shouldRenderExpansion(pageArr[pageArr.length - 1], maxPage) &&
                maxPage !== minPage &&
                renderPageItemButton(currentPage === maxPage, maxPage, onPageItemClick)),
        React.createElement(SelectorWrapper, null,
            React.createElement(ArrowButtonContainer, { disabled: currentPage === maxPage, Icon: Chevron, iconPosition: "RIGHT", onClick: onRightArrowClick, height: "SQUARE", width: "SQUARE", borderRadius: "NONE" }))));
};
export default PaginatorView;
//# sourceMappingURL=PaginatorView.js.map